import { Ticket } from './ticket';

export interface Incident extends Ticket {}

const model = {
	issueDate: 'response.retrieveOsmIncidentResponse.incident.issueDate',
	status: 'response.retrieveOsmIncidentResponse.incident.status',
	action: 'response.retrieveOsmIncidentResponse.incident.action',
	category: 'response.retrieveOsmIncidentResponse.incident.category',
	subcategory: 'response.retrieveOsmIncidentResponse.incident.subcategory',
	type: 'response.retrieveOsmIncidentResponse.incident.type',
	complaintType: 'response.retrieveOsmIncidentResponse.incident.complaintType',
	preferredLanguage: 'response.retrieveOsmIncidentResponse.incident.preferredLanguage',
	title: 'response.retrieveOsmIncidentResponse.incident.title',
	phase: 'response.retrieveOsmIncidentResponse.incident.phase',
};

export default model;
